import React from 'react';

import { IconTypes } from '@eika/icon';
import { Label, LabelTypes } from '@eika/label';
import { LinkCard } from '@eika/link-panel';

import { Link } from '../../defaultConfig';
import { taskManagerTrackingIDs } from '../../utils/gtm/trackIDs/taskManager';
import TaskManagerListItemSkeleton from './TaskManagerListItemSkeleton';
import type { TaskManagerType } from './TaskManagerTypes';

type Props = {
    title: string;
    link?: Link;
    isLoading?: boolean;
    type: TaskManagerType;
    count?: number;
    showWithEmptyCount?: boolean;
    labels?: { id: string; text: string; type: LabelTypes }[];
    attentionColor?: 'success' | 'danger';
    icon?: IconTypes;
} & React.PropsWithChildren;

const TaskManagerListItem: React.FC<Props> = ({
    link,
    title,
    isLoading,
    type,
    count = 0,
    showWithEmptyCount = false,
    children,
    labels = [],
    attentionColor,
    icon,
}) => {
    if (isLoading) return <TaskManagerListItemSkeleton>{children}</TaskManagerListItemSkeleton>;
    if (count === 0 && !showWithEmptyCount && !isLoading) return <></>;

    const dataTrackLinkname = labels.length > 0 ? `${title}-${labels[0].text}` : title;

    return link ? (
        <LinkCard
            labels={labels.map((label) => (
                <Label key={label.id} text={label.text} type={label.type} />
            ))}
            title={title}
            notification={count}
            formatNotification={(notification) => (notification > 99 ? '99+' : String(notification))}
            url={link.url}
            attentionColor={attentionColor}
            data-track-id={taskManagerTrackingIDs.taskManagerListItem.id}
            data-track-linkname={`${type}-${dataTrackLinkname}`}
            icon={icon}
        >
            {children}
        </LinkCard>
    ) : null;
};

export default TaskManagerListItem;
